import React from 'react';

import MultiValueSelector from "./MultiValueSelector";
import CountryFlag from "../CountryFlag";
import { getCountryName } from "../../../../../components/interop/countryCodeConverterFront"
import _ from 'lodash';
import __ from '../../../../../components/interop/i18n';

export default function MultiCountryEditor(props) {

  let options = _.map(__('countryCodeToName'), (name, countryCode) => ({value: countryCode, label: name}))

  options.push({value: 'latam', label: 'Latin America'});
  options.push({value: '*', label: '*'});

  const countryOrder = [
    'ar',
    'us',
    'mx',
    'br',
    'es',
    'gb',
    'au',
    'cl',
    'co'
  ];

  options = _.sortBy(options, op => countryOrder.includes(op.value) ? countryOrder.indexOf(op.value) : Infinity);

  const getOption = (props) => {
    let { innerProps, isSelected, isFocused } = props;
    let { innerRef, ...filteredProps } = innerProps;
    return <div {...filteredProps} className={'p-1 ' + ((isSelected || isFocused) ? 'bg-light-primary' : '')}>
      <CountryFlag countryCode={props.value}/> {getCountryName(props.label)}
    </div>;
  };

  const getValue = (props) => {
    return <span className={`small`} title={props.data.value}><CountryFlag countryCode={props.data.value}/></span>;
  };

  return <MultiValueSelector {...props} getOption={getOption} placeholder={'Countries...'} getValue={getValue} options={options}/>
}

